import React from "react";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import { handleSaveChangesButtonClick } from "./SiteAboutPageUtils/handleSaveChangesButtonClick";
import { useNavigate } from "react-router-dom";
import {
  AlertState,
  SiteSchedule,
  SiteInfo,
  PatchObject,
  WireGuardTunnel,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { WireGuardEditSession } from "./WireGuardTabEditMode";
import {
  selectAnyPhoneFieldInvalid,
  usePhoneValidationStore,
} from "../../../utils/phoneValidationStore";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const SaveChangesButton = ({
  patchObject,
  setEditMode,
  setSiteInfo,
  setPatchObject,
  siteInfo,
  clickedTab,
  setActiveTab,
  vmsVariables,
  allSiteSchedules,
  siteSchedules,
  setAllSiteSchedules,
  setBackdropLoadingScreenOn,
  setAlertState,
  setSyncNeeded,
  editMode,
  setSchedulesTabActive,
  setClickedTab,
  siteInfoChangesMade,
  setSiteInfoChangesMade,
  scheduleChangesMade,
  setScheduleChangesMade,
  setDeleteScheduleDialogOpen,
  setSiteSchedules,
  setArmButtonDisabled,
  recordingServerChangesMade,
  recordingServerData,
  recordingServerPatchObject,
  setRecordingServerData,
  setRecordingServerPatchObject,
  setRecordingServerChangesMade,
  cameraHealthChangesMade,
  healthCheckData,
  setHealthCheckData,
  cameraHealthPatchObject,
  setCameraHealthPatchObject,
  setCameraHealthChangesMade,
  setArmedStatus,
  webhooksChangesMade,
  webhooksInfo,
  setWebhooksInfo,
  webhooksPatchObject,
  setWebhooksPatchObject,
  setWebhooksChangesMade,
  setDeactivateSiteInsteadDialogOpen,
  setActivateSiteWithScheduleDialogOpen,
  wireguardChangesMade,
  wireGuardEditSessionRef,
  setWireguardTunnels,
  setWireguardChangesMade,
  wireguardTunnels,
  wireguardTunnelsLoading,
  selectedWireguardTunnelId,
  setSelectedWireguardTunnelId,
}: {
  patchObject: PatchObject;
  setEditMode: Dispatcher<boolean>;
  setSiteInfo: Dispatcher<SiteInfo>;
  setPatchObject: Dispatcher<PatchObject>;
  siteInfo: SiteInfo;
  clickedTab: string;
  setActiveTab: Dispatcher<JSX.Element>;
  vmsVariables: (string | string[] | undefined)[][];
  allSiteSchedules: SiteSchedule[];
  siteSchedules: SiteSchedule[];
  setAllSiteSchedules: Dispatcher<SiteSchedule[]>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setAlertState: Dispatcher<AlertState>;
  setSyncNeeded: Dispatcher<boolean>;
  editMode: boolean;
  setSchedulesTabActive: Dispatcher<boolean>;
  setClickedTab: Dispatcher<string>;
  siteInfoChangesMade: boolean;
  setSiteInfoChangesMade: Dispatcher<boolean>;
  scheduleChangesMade: boolean;
  setScheduleChangesMade: Dispatcher<boolean>;
  setDeleteScheduleDialogOpen: Dispatcher<boolean>;
  setSiteSchedules: Dispatcher<SiteSchedule[]>;
  setArmButtonDisabled: any;
  recordingServerChangesMade: any;
  recordingServerData: any;
  recordingServerPatchObject: any;
  setRecordingServerData: any;
  setRecordingServerPatchObject: any;
  setRecordingServerChangesMade: any;
  cameraHealthChangesMade: any;
  healthCheckData: any;
  setHealthCheckData: any;
  cameraHealthPatchObject: any;
  setCameraHealthPatchObject: any;
  setCameraHealthChangesMade: any;
  setArmedStatus: any;
  webhooksChangesMade: boolean;
  webhooksInfo: any;
  setWebhooksInfo: any;
  webhooksPatchObject: any;
  setWebhooksPatchObject: any;
  setWebhooksChangesMade: any;
  setDeactivateSiteInsteadDialogOpen: any;
  setActivateSiteWithScheduleDialogOpen: any;
  wireguardChangesMade: boolean;
  wireGuardEditSessionRef: React.MutableRefObject<WireGuardEditSession | null>;
  setWireguardTunnels: React.Dispatch<React.SetStateAction<WireGuardTunnel[]>>;
  setWireguardChangesMade: React.Dispatch<React.SetStateAction<boolean>>;
  wireguardTunnels: WireGuardTunnel[];
  wireguardTunnelsLoading: boolean;
  selectedWireguardTunnelId: number | null;
  setSelectedWireguardTunnelId: React.Dispatch<
    React.SetStateAction<number | null>
  >;
}) => {
  const navigate = useNavigate();
  // ENG-2302: never save an SMS recipient SNS would misdial.
  const phoneFieldInvalid = usePhoneValidationStore(selectAnyPhoneFieldInvalid);

  return (
    <div>
      <OrangeTextButton
        onClick={() =>
          handleSaveChangesButtonClick(
            patchObject,
            setEditMode,
            setSiteInfo,
            setPatchObject,
            siteInfo,
            clickedTab,
            setActiveTab,
            vmsVariables,
            siteSchedules,
            setAllSiteSchedules,
            setBackdropLoadingScreenOn,
            setAlertState,
            setSyncNeeded,
            editMode,
            setSchedulesTabActive,
            setClickedTab,
            siteInfoChangesMade,
            setSiteInfoChangesMade,
            // scheduleChangesMade,
            setScheduleChangesMade,
            setDeleteScheduleDialogOpen,
            navigate,
            setSiteSchedules,
            setArmButtonDisabled,
            recordingServerChangesMade,
            recordingServerData,
            recordingServerPatchObject,
            setRecordingServerData,
            setRecordingServerPatchObject,
            setRecordingServerChangesMade,
            cameraHealthChangesMade,
            healthCheckData,
            setHealthCheckData,
            cameraHealthPatchObject,
            setCameraHealthPatchObject,
            setCameraHealthChangesMade,
            setArmedStatus,
            webhooksChangesMade,
            webhooksInfo,
            setWebhooksInfo,
            webhooksPatchObject,
            setWebhooksPatchObject,
            setWebhooksChangesMade,
            setDeactivateSiteInsteadDialogOpen,
            setActivateSiteWithScheduleDialogOpen,
            wireguardChangesMade,
            wireGuardEditSessionRef,
            setWireguardTunnels,
            setWireguardChangesMade,
            wireguardTunnels,
            wireguardTunnelsLoading,
            selectedWireguardTunnelId,
            setSelectedWireguardTunnelId
          )
        }
        text="SAVE CHANGES"
        disabled={phoneFieldInvalid}
      />
    </div>
  );
};
